import axiosConfig from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axiosConfig });

export default function useGetFundAssetClasses() {
  return useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/lwadmin/fund_asset_classes',
    method: 'GET',
  }, { manual: true });
}
